<div class="report-container dashboard-widget-content">
    @if(loading()){
    <div class="overlay d-flex">
        <rask-busy-spinner class="m-auto" size="5"></rask-busy-spinner>
    </div>
    }

    <div class="d-flex">
        <a [href]="webRotstaendeLagerUrl$ | async" class="pillbox-wrapper" target="_blank">
            <rask-pillbox text="Rotstående lager">
                <i class="fas fa-external-link-alt ms-1"></i>
            </rask-pillbox>
        </a>
        <a [href]="webAvrakningshjalpenUrl$ | async" class="pillbox-wrapper" target="_blank">
            <rask-pillbox text="Avräkningshjälpen">
                <i class="fas fa-external-link-alt ms-1"></i>
            </rask-pillbox>
        </a>
    </div>

    <div class="visual-list" [ngClass]="{'loading': loading()}">
        @for(visual of visualItems; track visual.id){
        @if(getConfig(visual) | async; as conf){
        <div class="visual-item">
            <powerbi-visual
                cssClassName="h-100"
                [eventHandlers]="eventHandlers"
                [embedConfig]="conf">
            </powerbi-visual>
        </div>
        }
        @else {
        <div class="not-found-text">Resursen kunde inte hittas</div>
        }
        }
    </div>
</div>